export function toEnglishTerm(query: string): string {
  // 倒序排列，以便优先替换更长的词语
  const terms = Object.entries(termMap).sort(([key1], [key2]) => -key1.localeCompare(key2));
  const englishQuery = terms.reduce((result, [chineseTerm, englishTerm]) =>
    result.replace(new RegExp(chineseTerm, 'g'), `${englishTerm} `), query);
  return englishQuery.replace(/[^\w\s]/g, ' ');
}

const termMap: { [key: string]: string } = {
  生命: 'life',
  周期: 'cycle',
  钩子: 'hook',
  依赖: 'dependency',
  注入: 'inject',
  注入器: 'injector',
  令牌: 'token',
  提供者: 'provider',
  服务: 'service',
  模块: 'module',
  组件: 'component',
  指令: 'directive',
  模板: 'template',
  元数据: 'metadata',
  装饰器: 'decorator',
  函数: 'function',
  工厂: 'factory',
  管道: 'pipe',
  路由: 'route',
  路由器: 'router',
  预先: 'aot',
  编译: 'compile',
  编译器: 'compiler',
  预先编译: 'aot compile',
  元素: 'element',
  注解: 'annotation',
  应用外壳: 'app-shell',
  建筑师: 'architect',
  属性: 'propert',
  绑定: 'binding',
  引导: 'bootstrap',
  构建器: 'builder',
  大小写类型: 'case types',
  变更检测: 'change detection',
  类: 'class',
  字段: 'field',
  集合: 'collection',
  命令行: 'cli',
  内容: 'content',
  投影: 'projection',
  自定义: 'custom',
  数据: 'data',
  可声明对象: 'declarable',
  装饰: 'decorat',
  领域特定语言: 'dsl',
  动态: 'dynamic',
  加载: 'load',
  急性: 'eager',
  紧急: 'eager',
  入口点: 'entry point',
  表单: 'form',
  控件: 'control',
  模型: 'model',
  验证: 'validation',
  不可变性: 'immutability',
  可注入对象: 'injectable',
  输入: 'input',
  插值: 'interpolation',
  即时编译: 'jit',
  惰性: 'lazy',
  懒: 'lazy',
  库: 'library',
  生命周期: 'lifecycle',
  包: 'package',
  可观察对象: 'observable',
  观察者: 'observer',
  输出属性: 'output',
  平台: 'platform',
  腻子: 'polyfill',
  项目: 'project',
  响应式: 'reactive',
  解析器: 'resolver',
  守卫: 'guard',
  出口: 'outlet',
  规则: 'rule',
  原理图: 'schematic',
  范围化: 'scoped',
  渲染: 'render',
  呈现: 'render',
  独立: 'standalone',
  结构型: 'structural',
  订阅者: 'subscriber',
  目标: 'target',
  驱动: 'driven',
  表达式: 'expression',
  引用: 'reference',
  变量: 'variable',
  转译: 'transpile',
  目录树: 'tree',
  配置: 'config',
  单向: 'uni',
  双向: 'bidi',
  视图: 'view',
  视图树: 'view hierarchy',
  多层: 'hierarchy',
  分层: 'hierarchy',
  多级: 'hierarchy',
  层次化: 'hierarchy',
  工作区: 'workspace',
  区域: 'zone',
  封装: 'encapsulation',
  错误: 'error',
  事件: 'event',
  异常: 'exception',
  测试: 'test',
  表现: 'presentation',
  单例: 'singleton',
  搭建: 'setup',
  建立: 'setup',
  部署: 'deploy',
  构建: 'build',
  架构: 'architecture',
  交互: 'interact',
  样式: 'style',
  风格: 'style',
  内置: 'built',
  内建: 'built',
  组合: 'composition',
  变更: 'change',
  更改: 'change',
  变化: 'change',
  覆盖率: 'coverage',
  场景: 'scenario',
  国际化: 'i18n',
  无障碍: 'accessibility',
  可访问性: 'accessibility',
  本地化: 'localiz',
  语言环境: 'locale',
  翻译: 'translat',
  动画: 'animation',
  触发器: 'trigger',
  转场: 'transition',
  复用: 'reus',
  安全: 'security',
  浏览器: 'browser',
  命令: 'command',
  特性: 'feature',
  选择器: 'selector',
  选择: 'select',
  流: 'observable',
  访问: 'access',
  值: 'value',
  活动: 'active',
  活跃: 'active',
  脚本: 'script',
};
